import * as React from 'react';
import './Page404.css';

const Page404 = () => (
  <div className="d-flex m-auto flex-column align-items-center justify-content-center">
    <p className="title404">404</p>
    <p className="subtitle404">Page not found</p>
  </div>
);

export default Page404;



// WEBPACK FOOTER //
// ./src/containers/Page404/Page404.tsx